import { Avatar, Drawer, Skeleton } from "antd";
import { calculateTimeDifference } from "common/enums";
import AppResult from "components/appResults";
import Matiers from "components/matiers";
import React, { FC, useEffect, useState } from "react";
import { useGetHistoriqueReservationsStudentQuery } from "store/services/teacher/classes.services";
import ArrowBack from "../../../../assets/images/app/arrow_back.svg";
import ClockIcon from "../../../../assets/images/app/clock_icon.svg";
import Star from "../../../../assets/images/app/start.svg";
import s from "../../../student/calendar/assets/calendar.module.css";

type Props = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  user: any;
};

interface CoursesRoomProps {
  course?: object | any;
}

const CoursesRoom: FC<CoursesRoomProps> = ({ course }) => {

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1050);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 1050);
  };
  window.addEventListener('resize', handleResize);

  return (
    <>
      <div className={s.historyClasseCard} style={{ cursor: "pointer" }}>
        <div className={s.cardClassBox}>
          <div className={s.avatarNameBox}>
            <Avatar.Group
              maxCount={3}
              maxStyle={{
                color: "#f56a00",
                backgroundColor: "#fde3cf",
              }}
              style={{ marginRight: isMobile ? "0px" : "5px" }}
            >
              <Avatar
                size={45}
                style={{ backgroundColor: "#FFF2E0", boxShadow: "0px 3px 6px #00000029" }}
                src={course?.profId?.profile}
              />
            </Avatar.Group>
            <div style={{ position: "relative", left: isMobile ? "0px" : "15px", fontSize: isMobile ? "0.8em" : "13px", textTransform: "capitalize" }}>{course?.profId?.firstname + " " + course?.profId?.lastname}</div>
          </div>
          {isMobile && <Matiers
            cours={course?.topic?.title || "null"}
            level={course?.level?.title || "null"}
          />}
          <div className={s.historyDetailsBox}>
            <div className={s.timeBox}>
              {!isMobile && <img src={ClockIcon} height={15} style={{ marginRight: isMobile ? "0px" : "10px" }}></img>}
              <div className={s.times}>
                <span className={s.time}>{isMobile && <img src={ClockIcon} height={10} style={{ marginRight: isMobile ? "5px" : "10px" }}></img>} De {course?.range[0]} à {course?.range[course?.range?.length - 1]}</span>
                <span className={s.timeDescription}>Séance de “{calculateTimeDifference(course?.range[0], course?.range[course?.range.length - 1])}”</span>
              </div>
            </div>
            {!isMobile && <Matiers
              cours={course?.topic?.title || "null"}
              level={course?.level?.title || "null"}
            />}
            {course?.codeCoupon && (course?.codeCoupon?.couponType === "FREE_CLASS" || course?.codeCoupon?.couponType === "FREE_LINK_DISCOUNT") ? <div className={s.historyPriceBox}>Cours gratuit</div> : <div className={s.historyPriceBox}>{(course?.byCredits === "oui" || course?.byCredits === "true") ? course?.creditedValue + " Crédit" : course?.price + " €"}</div>}
          </div>

          {course.teacherNoted && <div className={s.rateBox}>
            <div className={s.dashedBox}>
              <span style={{ color: "#7FB1B2" }}>Cours</span>
              <span className={s.rateBoxSpan}><img src={Star} height={10} className={s.rateBoxStar}></img>{course?.teacherRating?.rateCours}</span>
            </div>
            <div className={s.dashedBox}>
              <span style={{ color: "#7FB1B2" }}>Application</span>
              <span className={s.rateBoxSpan}><img src={Star} height={10} className={s.rateBoxStar}></img>{course?.teacherRating?.rateApplication}</span>
            </div>
            <div className={s.dashedBox}>
              <span style={{ color: "#7FB1B2" }}>Exercice</span>
              <span className={s.rateBoxSpan}><img src={Star} height={10} className={s.rateBoxStar}></img>{course?.teacherRating?.rateExercice}</span>
            </div>
          </div>}
        </div>
      </div>
    </>
  );
};

const DrawerHistorique: FC<Props> = ({ open, setOpen, user }) => {

  const {
    data: historiques,
    isLoading,
    isSuccess,
  } = useGetHistoriqueReservationsStudentQuery(user?._id);

  const [courses, setCourses] = useState<any>([]);

  useEffect(() => {
    if (historiques?.data) {
      const sortedCourses = [...historiques.data].sort(
        (a: any, b: any) => new Date(b.startDate).getTime() - new Date(a.startDate).getTime()
      );

      const groupedByDate = sortedCourses.reduce((acc: any, course: any) => {
        const date = new Date(course.startDate).toISOString().split("T")[0];
        if (!acc[date]) {
          acc[date] = [];
        }
        acc[date].push(course);
        return acc;
      }, {});

      setCourses(groupedByDate);
    }
  }, [historiques]);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const [isXsScreen, setIsXsScreen] = useState(window.innerWidth > 767 && window.innerWidth <= 1151);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth > 1151 && window.innerWidth <= 1321);
  const [isMediumScreen, setIsMediumScreen] = useState(window.innerWidth > 1321 && window.innerWidth <= 1606);
  const [isNormalScreen, setIsNormalScreen] = useState(window.innerWidth > 1606 && window.innerWidth <= 1799);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 767);
    setIsXsScreen(window.innerWidth > 767 && window.innerWidth <= 1151);
    setIsSmallScreen(window.innerWidth > 1151 && window.innerWidth <= 1321);
    setIsMediumScreen(window.innerWidth > 1321 && window.innerWidth <= 1606);
    setIsNormalScreen(window.innerWidth > 1606 && window.innerWidth <= 1799);
  };
  window.addEventListener('resize', handleResize);

  return (
    <>
      <Drawer
        className="drawer"
        visible={open}
        onClose={() => setOpen((open: boolean) => !open)}
        title={<div style={{ fontSize: isMobile ? "0.8em" : "20px", fontFamily: "Poppins", fontWeight: "600", color: "#393E3E", backgroundColor: "transparent" }}>Mon historique</div>}
        width={isMobile ? "100%" : isXsScreen ? "100%" : isSmallScreen ? "85%" : isMediumScreen ? "80%" : isNormalScreen ? "70%" : "65%"}
        headerStyle={{ border: "none", paddingTop: "50px", paddingLeft: isMobile ? "20px" : "40px", backgroundColor: "transparent" }}
        closeIcon={
          <img
            src={ArrowBack}
            height={isMobile ? 10 : 18}
            style={{}}
          ></img>
        }
        drawerStyle={{ backgroundColor: "#FFF", borderTopLeftRadius: isMobile ? "0px" : "30px", borderBottomLeftRadius: isMobile ? "0px" : "30px", boxShadow: "-3px 3px 34px #39393929" }}
      >
        {isLoading ? (
          <>
            <Skeleton />
            <Skeleton />
            <Skeleton />
            <Skeleton />
            <Skeleton />
          </>
        ) : (<div className={s.historyCalendar}>
          {historiques?.data?.length > 0 ? (
            courses && Object.keys(courses)?.map((date) => {
              return (
                <>
                  <div key={date} style={{ marginTop: "10px" }}>
                    <div className={s.dateBox}>
                      {new Intl.DateTimeFormat("fr-FR", {
                        weekday: "long",
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                      }).format(new Date(date))}
                      <div className={s.horizontalLine}></div>
                    </div>
                    {!isMobile && courses[date].map((course: any) => (
                      <div key={course.id}>
                        <CoursesRoom course={course} />
                      </div>
                    ))}

                    {isMobile && <div className={s.cardDisplay}>
                      {courses[date].map((course: any) => (
                        <div key={course.id}>
                          <CoursesRoom course={course} />
                        </div>
                      ))}
                    </div>}
                  </div>
                </>
              );
            })
          ) : (
            <div className={s.emptyClass}>
              <AppResult status={"info"} title="Aucune séance" />
            </div>
          )}
        </div>
        )}
      </Drawer>
    </>
  );
};

export default DrawerHistorique;
